<!-- <div class="wrapper bg-white">
    <header class="navbar navbar-expand d-flex align-items-center"></header>
    <div class="container-fluid px-0">
        <div class="announcement-wrapper">
            <service-announcement></service-announcement>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>
<footer></footer> -->
<router-outlet></router-outlet>

